<div *ngIf="apiLoaded">
	<google-map #map [zoom]="zoom" [center]="center" [options]="options">
		<map-marker *ngFor="let marker of markers" [position]="marker.position" [options]="marker"
			[clickable]="clickable">
		</map-marker>
	</google-map>
</div>